import { Stack } from '@mui/material';
import RoundImage from './RoundImage';
import androidApp from 'assets/images/androidGuide/and-app.png';
import GuideTypo from './GuideTypo';
import { ATT_APP_INSTALL_URL } from 'constants/frontend/values';

function AndroidGuide() {
  const url = ATT_APP_INSTALL_URL;
  return (
    <Stack
      spacing={4}
      sx={{
        width: '320px',
        margin: '0 auto',
      }}
    >
      <GuideTypo>
        안드로이드용 출결앱은 플레스토어에서 받을 수 있습니다. &nbsp;
        <a href={url}>플레이스토어 가기</a>
        <a href={url}>
          <RoundImage src={androidApp} />
        </a>
      </GuideTypo>
    </Stack>
  );
}

export default AndroidGuide;
